var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeModalBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FFEDE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3337 38.3334V61.6667C63.3337 62.5872 62.5875 63.3334 61.667 63.3334H58.3337C57.4132 63.3334 56.667 62.5872 56.667 61.6667V38.3334C56.667 37.4129 57.4132 36.6667 58.3337 36.6667H61.667C62.5875 36.6667 63.3337 37.4129 63.3337 38.3334ZM53.3337 61.6667V45C53.3337 44.0795 52.5875 43.3334 51.667 43.3334H48.3337C47.4132 43.3334 46.667 44.0795 46.667 45V61.6667C46.667 62.5872 47.4132 63.3334 48.3337 63.3334H51.667C52.5875 63.3334 53.3337 62.5872 53.3337 61.6667ZM41.667 63.3334H38.3337C37.4132 63.3334 36.667 62.5872 36.667 61.6667V51.6667C36.667 50.7462 37.4132 50 38.3337 50H41.667C42.5875 50 43.3337 50.7462 43.3337 51.6667V61.6667C43.3337 62.5872 42.5875 63.3334 41.667 63.3334Z",
    fill: "#FF4100"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeModalBar);
export default __webpack_public_path__ + "static/media/welcome-modal-bar.55b25d7ddf6a16aacecfafd13d026ce9.svg";
export { ForwardRef as ReactComponent };